import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isAndroid, isIOS } from "react-device-detect";

const AppRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isAndroid) {
      window.location.href = process.env.REACT_APP_PLAYSTORE_URI;
    } else if (isIOS) {
      window.location.href = process.env.REACT_APP_APPSTORE_URI;
    } else {
      navigate("/");
    }
  }, [navigate]);

  return null;
};

export default AppRedirect;
